module.exports = __webpack_public_path__ + "img/ppt.60f784d6.png";